export enum GenericEvents {
	NOTIFY_ME_SHOW = 'notify_me_show',
	NOTIFY_ME_SEND_SUCCEED = 'notify_me_send_succeed',
}
